import React, {Component, Fragment} from "react"
import {Link} from "react-router-dom"
import shop from "shop/shop"
import {observer} from "mobx-react"
import {Button, Icon, Popup, Container,Image, Progress} from "semantic-ui-react"

import Price from "components/Price/Price"
import MinOrderValue from "components/Cart/MinOrderValue"
import MinOrderFreeValue from "components/Cart/MinOrderFreeValue"
import queryString from "qs"

@observer
export default class CartTotalMinimum extends Component {

	constructor() {
		super()
		this.state = {
			sum: 0,
            showCalc:   false,
		}
	}
    componentDidMount() {
    }


	render() {
        let { located } = this.props
		let { loading} = shop.cart
        let { sum, deliveraddress } = shop.cart.data
		const MIN_ORDER_VALUE = Number( shop.config.MIN_ORDER_VALUE ) || 0
        const MIN_ORDER_FREE_VALUE = Number( shop.config.MIN_ORDER_FREE_VALUE ) || 0
		const aboveMin = !shop.config.MIN_ORDER_VALUE || (Number(sum) > shop.config.MIN_ORDER_VALUE)
		let aboveMinFree = !shop.config.MIN_ORDER_FREE_VALUE || (Number(sum) > shop.config.MIN_ORDER_FREE_VALUE)
		let shippingCosts = sum <= 100 ? "9,95" : (sum >= 150 ? "0,00" : "7,95");
        console.log("shop.cart.data.deliveraddress",shop.cart.data.deliveraddress, "TEST ", deliveraddress)
        if(shop.session && shop.session.shopuser){
            aboveMinFree = !shop.config.MIN_ORDER_FREE_VALUE || 
            (Number(sum) >= shop.config.MIN_ORDER_FREE_VALUE) || 
            (shop.cart.data.deliveraddress && shop.cart.data.deliveraddress.extras && 
             (shop.cart.data.deliveraddress.extras.lieferart == "EL" || 
              shop.cart.data.deliveraddress.extras.lieferart == "Abholung")) || 
            (shop.cart.data.deliveraddress && Object.keys(shop.cart.data.deliveraddress).length === 0 && shop.session.value && shop.session.value.extras && 
             (shop.session.value.extras.lieferart == "EL" || 
              shop.session.value.extras.lieferart == "Abholung"));
        }
        shippingCosts = "9.95";
        aboveMinFree = false; // for testing
        //console.log("shop.config",shop.config)
        //console.log("shop.session",shop.cart.data.deliveraddress)
        //console.log("aboveMinFree",aboveMinFree, shippingCosts, sum, MIN_ORDER_FREE_VALUE)
		if ( !shop.session ) return null
        if(located == "HeaderMenu"){
            return (
                <div className="CartButton relative">
                    <Button style={{backgroundColor: "#346E5B", width: "60px", height: "40px", borderRadius: "20px"}}
                        primary
                        className=""
                        onMouseEnter={() => this.setState( {showCalc: true} )}
                        onMouseLeave={() => this.setState( {showCalc: false} )}
                    ><p style={{color: "#346E5B", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", height: "100%" }}>
                        <Popup trigger={
                            <React.Fragment>
                                {aboveMin ? <Icon className="white big check mark" /> : <Icon name={"white big warning circle"} />}
                            </React.Fragment>
                        }>
                        </Popup></p>
                    </Button>
                        <div className="" >
                            
            {this.state.showCalc && <div style={{ padding: 0 , width: "1220px", alignContent: "center", zIndex: "99", background: "transparent", animation: "fadeIn 0.5s",}} 
                className="absolute bg-white z-99  variantsContainer " >
                    <div style={{ alignContent: "center", width: "600px", zIndex: "99",marginLeft: "-540px", borderRadius: "20px"}}  className="justify-between bg-white pa3 VariantsPullDownCart shadow-3">
                        
                        <div className="pt4 mb4 mt4 pb2 fw5 f4 bt bw2 w-60"><p className=" black-40">{translate("Ihr aktueller Bestellwert: ")}<Price>{sum}</Price></p></div>
                        <div style={{backgroundColor: "#ffffffff"}} className="">
                        <table className="pb3">
                        <colgroup>
                            <col width="85%"/>
                            <col width="15%"/>
                        </colgroup>
                        <tbody>
                            <tr>
                            <td>
                                {!aboveMinFree && <div className="pb3 fw5 f4">{translate("Kostenloser Versand erreicht in: ")}&nbsp;</div>}
                                {!aboveMinFree && <div className="pb3  fw5 f4">{translate("Lieferkosten: ")}</div>}
                                {aboveMinFree && <div className="pb3  fw5 f4">{translate("Kostenloser Versand erreicht!")}</div>}
                            </td>
                            <td className="fw5 f4 fr">
                                {!aboveMinFree && <div className="pb3 fw6 fr"><Price>{MIN_ORDER_FREE_VALUE-sum}</Price></div>}
                                {!aboveMinFree && <div className="pb3 fw6 fr"><Price>{Number(shippingCosts)}</Price></div>}</td>
                            </tr>
                            <tr>
                            <td>{!aboveMinFree && <MinOrderFreeValue sum={sum} />}</td>
                            </tr>
                        </tbody>    
                        </table>

                            <table className="pt3">
                        <colgroup>
                            <col width="15%"/>
                            <col width="70%"/>
                            <col width="15%"/>
                        </colgroup>
                        <tbody>
                            <tr>
                            <td>
                                <Image className="w-40 h-40" src={`/arrowdownright.png`}/>
                                </td>
                            <td>
                                {!aboveMin && <div className="pb2  fw5 f4">{translate("Mindestbestellwert erreicht in: ")}</div>}
                                {aboveMin && <div className="pb2  fw5 f4">{translate("Mindestbestellwert erreicht!")} </div>}
                            </td>
                            <td className=" fw6 f4 tr">
                                {!aboveMin && <Price>{MIN_ORDER_VALUE-sum}</Price>}</td>
                            </tr>
                            <tr>
                                <td></td>
                            <td>{!aboveMin && <MinOrderValue sum={sum} />}</td>
                            </tr>
                        </tbody>    
                        </table>
                        </div>
                    </div></div>}
                    </div>
                </div>
            );
        }
        if(located == "ProductPage"){
            return (
                <div  className=" bg-white" >
                    <div  className="justify-between bg-white ">
                        
                        <div className="pt4 mb4 mt4 pb2 fw5 f4 bt bw2 w-60"><p className=" black-40">{translate("Ihr aktueller Bestellwert: ")}<Price>{sum}</Price></p></div>
                        <div style={{backgroundColor: "#ffffffff"}} className="">
                        <table className="pb3">
                        <colgroup>
                            <col width="85%"/>
                            <col width="15%"/>
                        </colgroup>
                        <tbody>
                            <tr>
                            <td>
                                {!aboveMinFree && <div className="pb3 fw5 f4">{translate("Kostenloser Versand erreicht in: ")}&nbsp;</div>}
                                {!aboveMinFree && <div className="pb3  fw5 f4">{translate("Lieferkosten: ")}</div>}
                                {aboveMinFree && <div className="pb3  fw5 f4">{translate("Kostenloser Versand erreicht!")}</div>}
                            </td>
                            <td className="fw5 f4 fr">
                                {!aboveMinFree && <div className="pb3 fw6 fr"><Price>{MIN_ORDER_FREE_VALUE-sum}</Price></div>}
                                {!aboveMinFree && <div className="pb3 fw6 fr"><Price>{Number(shippingCosts)}</Price></div>}</td>
                            </tr>
                            <tr>
                            <td>{!aboveMinFree && <MinOrderFreeValue sum={sum} />}</td>
                            </tr>
                        </tbody>    
                        </table>

                            <table className="pt3">
                        <colgroup>
                            <col width="15%"/>
                            <col width="70%"/>
                            <col width="15%"/>
                        </colgroup>
                        <tbody>
                            <tr>
                            <td>
                                <Image className="w-40 h-40" src={`/arrowdownright.png`}/>
                                </td>
                            <td>
                                {!aboveMin && <div className="pb2  fw5 f4">{translate("Mindestbestellwert erreicht in: ")}</div>}
                                {aboveMin && <div className="pb2  fw5 f4">{translate("Mindestbestellwert erreicht!")} </div>}
                            </td>
                            <td className=" fw6 f4 tr">
                                {!aboveMin && <Price>{MIN_ORDER_VALUE-sum}</Price>}</td>
                            </tr>
                            <tr>
                                <td></td>
                            <td>{!aboveMin && <MinOrderValue sum={sum} />}</td>
                            </tr>
                        </tbody>    
                        </table>
                        </div>
                    </div></div>
            )
        }
	}
}





// WEBPACK FOOTER //
// ./src/theme/trendimport.test/components/Cart/CartTotalMinimum.js